import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
const useIsAdvancedSearch = () => {
  const location = useLocation();
  const pathname = location?.pathname ?? "";
  const isAdvancedSearch = pathname === "/search" || pathname === "/search/";
  return isAdvancedSearch;
};
export default useIsAdvancedSearch;